import { mongoId } from "../../../@core/common/global";
import { DateSelectionData } from "../../../@models/erp/compilationData";

const moment = require('moment');

const today = moment().toDate();
const monday = moment().startOf('isoWeek').toDate();
const sunday = moment().endOf('isoWeek').toDate();
const lastMonday = moment(monday).subtract(1, 'week').toDate();
const lastSunday = moment(sunday).subtract(1, 'week').toDate();
const last2Monday = moment(monday).subtract(2, 'week').toDate();
const last2Sunday = moment(sunday).subtract(2, 'week').toDate();
const nextMonday = moment(monday).add(1, 'week').toDate();
const nextSunday = moment(sunday).add(1, 'week').toDate();
const sundayAfterNext = moment(nextSunday).add(1, 'week').toDate();
const firstDay = moment().startOf('month').toDate();
const lastDay = moment().toDate();
const prevFirst = moment(firstDay).subtract(1, 'month').toDate();
const prevLast = moment(firstDay).subtract(1, 'day').toDate();
const last4CW = moment(monday).subtract(4, 'week').toDate();
const last5CW = moment(monday).subtract(5, 'week').toDate();
const next4CW = moment(sunday).add(4, 'week').toDate();

export const defaultReport = {
  offers: {
    orientation: 'portrait',
    issuer: null, // Number, // CompilationData::IssuerData
    // customer: null, // BusinessModel,
    customers: [],
    manager: null, // ContactModel,
    sortByManager: false,
    filterInternal: false,
    // businessUnit: null,
    businessUnits: [],
    finishedProduct: null,
    finishedProducts: [],
    customerDocumentNumbers: [],
    country: null,
    offerStatus: [],
    sampleRequest: 1, // 1 = All, 2 = SR only, 3 = no SR,
    sortOrder: 2, // 1 == none, 2 == new to old, 3 == old to new, 10 = new business first, 11 active business first
    dateType: DateSelectionData.thisCalendarWeek.id,
    dateFrom: null,
    dateTo: null,
    dateField: 'issueDate', // 'offerValidity'
    fromMainMenu: false,
    extended: false,
  },
  orders: {
    orientation: 'portrait',
    issuer: null, // Number, // CompilationData::IssuerData
    // customer: null, // BusinessModel,
    customers: [],
    manager: null, // ContactModel,
    sortByManager: false,
    filterInternal: true,
    // businessUnit: null,
    businessUnits: [],
    finishedProduct: null,
    finishedProducts: [],
    customerDocumentNumbers: [],
    country: null,
    sampleRequest: 1, // Number,
    order: null, // order number (code)
    orderNumberVersioned: null,
    orNotCompleted: true,
    relatedOcs: 2, // 1 = none, 2 = all, 3 = non invoiced
    relatedInvoices: 2, // 1 = none, 2 = all, 11 = not paid, 12 = partially paid, 13 = fully paid
    relatedCreditNotes: 2, // 1 = none 2 = all
    relatedSPOs: 2, // 1 = none 2 = all
    showMarkup: 3, // 1 = no markup, 2 = markup, 3 = markup split per OC
    dateType: DateSelectionData.thisCalendarWeek.id,
    noOC: false,
    dateFrom: null,
    dateTo: null,
  },
  noninvoiced: {
    orientation: 'portrait',
    issuer: null, // Number, // CompilationData::IssuerData
    customers: [], // BusinessModel,
    manager: null, // ContactModel,
    sortByManager: false,
    filterInternal: false,
    combinedShipments: [],
    // businessUnit: null,
    businessUnits: [],
    finishedProduct: null,
    finishedProducts: [],
    country: null,
    trial: null,
    sampleRequest: 1, // Number,
    // customerName: null,
    customerReference: null,
    customerDocumentNumber: null,
    customerDocumentNumbers: [],
    placeOfLoading: null,
    sortType: 3, // 3 = Next invoice date, 1 = Customer Req delivery date, 2 = Dispatch date to final customer
    showUnconfirmed: 1, // 1 = yes, 2 = no, 3 = nonconfirmed only (dispatch dates)
    notConfirmedOCsOnly: false, // only show OCs, if associated PFSPO is NOT confirmed
    showRelatedPFSPOs: true,
    noPrices: false,
    dateType: DateSelectionData.past365TillNextMonth.id,
    dateFrom: null,
    dateTo: null,
    poDateFrom: -1,
    poDateTo: -1,
    fiscalYear: null,
    internal: null,
    supplierRef: null,
    showInvoicedOCs: false,
    projectOverview: false,
    filterCompletedProjects: false,
    projectNumber: null,
    units: [true, true, true, true, true, true],
    unitConversion: null, // [ x, 1=pc, 2=m, 3=100m, 4=m2, 5=kg] --> UnitData
    opensrs: false,
    srStatus: [true, true, true, true],
    reverseSort: false,
    manufacturer: [true, true, true],

    //invoiceStatus: 1, // 1 = All, 2 = Not invoiced, 3 = Invoiced ( only for deliverynotes )
  },
  deliverynotes: {
    // populated in constructor (with noninvoiced defaults)
  } as any,
  projectoverview: {
    // populated in constructor (with noninvoiced defaults)
  } as any,
  openspo: {
    orientation: 'landscape',
    issuer: null, // Number, // CompilationData::IssuerData
    // customer: null, // BusinessModel,
    customers: [],
    finishedProduct: null,
    finishedProducts: [],
    country: null,
    sampleRequest: 1, // Number,
    docs: { spo: true, spc: true, pfspo: true, pfspc: true },
    spoWithOC: 1, // 1 = all, 2 = spo without oc, 3 = spo with oc
    documentNumber: null,
    meansOfTransport: null,
    spoStatus: { unconfirmed: true, confirmed: true, completed: true },
    transportStatus: { planned: true, enRoute: true, completed: true },
    availabilityStatus: null, // 1 = not completed, 2 = completed,
    combinedShipment: null,
    obic: null,
    // customerName: null,
    customerReference: null,
    customerDocumentNumber: null,
    customerDocumentNumbers: [],
    sortType: 5, // 5 = Pickup date, Means of transport, CS #, PFSPO #; 1 = EXW date, Means of transport, CS #, PFSPO #; 2 = Document #, 3 = Dispatch date, Document #
      // 6 = customer reference: name, 7 = box age
      // timeline: 101 = sort by customer, 102 = sort by product
    dateField: 1, // 1 = EXW date, 2 = Dispatch date
    allDocs: false,
    showRelatedOCs: true,
    noPrices: false,
    dateType: DateSelectionData.nextYear365.id,
    dateFrom: null,
    dateTo: null,
  },
  cs: {
    issuer: null,
    customers: [],
    meansOfTransport: null,
    transportStatus: { planned: true, enRoute: true, completed: true },
    obic: null,
    customerReference: null,
    customerDocumentNumber: null,
    availabilityStatus: null, 
    dateType: DateSelectionData.nextYear365.id,
    dateField: 1, // 1 = EXW date, 2 = Dispatch date
    dateFrom: null,
    dateTo: null,
  },
  invoiced: {
    orientation: 'portrait',
    customer: null, // BusinessModel,
    customers: [],
    manager: null,
    businessUnit: null,
    status: { final: true, draft: false, cancelled: false, revised: false },
    dateType: DateSelectionData.lastYear365.id,
    dateFrom: null,
    dateTo: null,
    fiscalYear: null,
  },
  openorders: {
    orientation: 'portrait',
    allOCs: false,
    customer: null, // BusinessModel,
    customers: [],
    manager: null,
    businessUnit: null,
    status: { final: true, draft: false, cancelled: false, revised: false },
    dateType: DateSelectionData.past365ToNext365.id,
    dateFrom: null,
    dateTo: null,
  },
  invoicedandopenorders: {
    orientation: 'portrait',
    customer: null, // BusinessModel,
    customers: [],
    manager: null,
    finishedProducts: [],
    businessUnit: null,
    status: { final: true, draft: false, cancelled: false, revised: false },
    quantitySummary: false,
    quantitySummaryUnit: 1,
    dateType: DateSelectionData.lastYear365.id,
    dateFrom: null,
    dateTo: null,
    fiscalYear: null,
  },
  pricematrix: {
    orientation: 'portrait',
    issuer: null, // Number, // CompilationData::IssuerData
    // customer: null, // BusinessModel,
    customers: [],
    manager: null, // ContactModel,
    sortByManager: false,
    filterInternal: false,
    // businessUnit: null,
    businessUnits: [],
    baseProduct: null,
    finishedProduct: null,
    sampleRequest: 1, // Number,
    priceType: 1,
    // dateType: DateSelectionData.thisCalendarWeek.id,
    dateFrom: -1,
    dateTo: -1,
    effectiveDate: new Date(),
  },
  dueinvoices: {
    orientation: 'portrait',
    issuer: null, // Number, // CompilationData::IssuerData
    // customer: null, // BusinessModel,
    customers: [],
    manager: null, // ContactModel,
    sortByManager: false,
    filterInternal: false,
    // businessUnit: null,
    businessUnits: [],
    finishedProduct: null,
    finishedProducts: [],
    dueStatus: 1, // 2 = Only due, 3 = Only overdue, 1 = all
    customerDocumentNumbers: [],
    country: null,
    sampleRequest: 1, // Number,
    invoiceStatus: {
      notPaid: true,
      partiallyPaid: true,
      fullyPaid: false,
      notCollectible: false,
    },
    dateType: DateSelectionData.allTillNextWeek.id,
    dateFrom: null,
    dateTo: null,
    fiscalYearMismatch: 1, // 1 = All, 2 = Fiscal Year Mismatch, 3 = Fiscal Year Match
    fiscalYear: null,
  },
  lastinvoices: {
    orientation: 'portrait',
    issuer: null, // Number, // CompilationData::IssuerData
    // customer: null, // BusinessModel,
    customers: [],
    manager: null, // ContactModel,
    sortByManager: false,
    filterInternal: false,
    // businessUnit: null,
    businessUnits: [],
    finishedProduct: null,
    finishedProducts: [],
    customerDocumentNumbers: [],
    country: null,
    sampleRequest: 3, // Number,
    docs: {
      in: true,
      pfin: true,
      cn: true,
      pfcn: true,
    },
    transactionReceipt: 3,
    proveOfDelivery: 3,
    testCertificate: 3,
    showRelatedPFSPOs: true,
    dateType: DateSelectionData.thisCalendarWeek.id,
    dateFrom: null,
    dateTo: null,
    fiscalYearMismatch: 1, // 1 = All, 2 = Fiscal Year Mismatch, 3 = Fiscal Year Match
    fiscalYear: null,
    extended: 1,
  },
  spopayment: {
    recipients: [],
    customerReference: [],
    customerDocumentNumber:[],
    fiscalYear: null,
    dateType: DateSelectionData.all.id,
    dateFrom: null,
    dateTo: null,
    noncompleteOnly: false,
  },
  customeroverview: {
    orientation: 'portrait',
    // dateType: DateSelectionData.currentYear.id,
    manager: null,
    issuer: null,
    country: null,
    dateType: DateSelectionData.yearToDate.id,
    dateFrom: new Date(new Date().getFullYear() + '-01-01'),
    dateTo: new Date(),
    customers: [],
    businessUnits: [],
    trial: null,
    finishedProduct: null,
    finishedProducts: [],
    customerDocumentNumbers: [],
    relatedSPOs: 2,
    quickLink: 0,

    years: 3,
    attachedReports: {
      lastinvoices: { show: true, offset: 0, limit: 10, text: 'Invoices' },
      dueinvoices: { show: true, offset: 0, limit: 10, text: 'Due invoices' },
      orders: { show: true, offset: 0, limit: 10, text: 'Orders' },
      noninvoicedEM: { show: true, offset: 0, limit: 10, text: 'Non invoiced OCs (EM)' },
      noninvoicedMachinery: { show: true, offset: 0, limit: 10, text: 'Non invoiced OCs (Machinery)' },
      srnoninvoiced: { show: true, offset: 0, limit: 10, text: 'Non invoiced OCs (Sample requests)' },
      srpfin: { show: true, offset: 0, limit: 10, text: 'Proforma invoices (Sample requests)' },
      offers: { show: true, offset: 0, limit: 10, text: 'Offers' },
    },
    sort: ['lastinvoices', 'dueinvoices', 'orders', 'noninvoicedEM', 'noninvoicedMachinery', 'srpfin', 'srnoninvoiced', 'offers'],
    showCharts: true,

    sortByManager: false,
    // quickLinkDateSelection: new Date(),
    buFilter: {
      all: true,
      machinery: false,
      energy: false,
      composite: false,
    }
  },
  baseProducts: {
    businessUnits: [],
    products: []
  },
  finishedProducts: {
    businessUnits: [],
    products: []
  },
  srpfin: null,
  srnoninvoiced: null,
  noninvoicedEM: null,
  noninvoicedMachinery: null,
  boxes: {
    placeOfLoading: null,
    customers: [],
    dnRecipients: [],
    baseProducts: [],
    finishedProducts: [],
    suppliers: [],
    date: new Date(),
    dateType: DateSelectionData.all.id,
    dateFrom: null,
    dateTo: null,
    stockStatus: {
      notInInventory: false,
      onStock: false,
      shipped: false,
    },
    sort: 1, // 1: customer - SPO product - SPO arrival date
    expiryReport: false,
    withOCBoxPrice: true,
    simple: false,
    doc: null,
    dn: null,
    extended: null,
    boxType: null,
  },
  inventory: {
    // populated in constructor / ngOnInit (with boxes defaults)
  } as any,
  inventoryMonthly: {
  } as any,
}

defaultReport.srpfin = { ...defaultReport.lastinvoices }
defaultReport.srpfin.sampleRequest = 2 // sr only
defaultReport.srnoninvoiced = { ...defaultReport.noninvoiced }
defaultReport.srnoninvoiced.sampleRequest = 2 // sr only
defaultReport.noninvoicedEM = { ...defaultReport.noninvoiced }
defaultReport.noninvoicedMachinery = { ...defaultReport.noninvoiced } 

export const getReportOverviewFields = (report: string, link: number, buNames = ['All'], data: any = null) => {

  const getFilename = (num, name, sr = false) => {
    if (data?.reportNum === 4) {
      buNames = ['EM'];
    } else if ([401, 411].includes(data?.reportNum)) {
      buNames = ['Machinery'];
    }
    const filename = num < 10 
      ? link < 2 
        ? `${moment().format('YY')}CW${(link === 1 ? moment().subtract(1, 'week') : moment()).format('WW')}_0${num}_${name}_${buNames.join('_')}${sr ? '_SR' : ''}`
        : `${moment().format('YYMM')}_0${num}_${name}_${buNames.join('_')}${sr ? '_SR' : ''}`
      : link < 2 
        ? `${moment().format('YY')}CW${(link === 1 ? moment().subtract(1, 'week') : moment()).subtract(1, 'week').format('WW')}_${num}_${name}_${buNames.join('_')}${sr ? '_SR' : ''}`
        : `${moment().format('YYMM')}_${num}_${name}_${buNames.join('_')}${sr ? '_SR' : ''}`
    // console.log('filename', filename, num, buNames, data);
    return filename;
  }
  
  switch (report) {
    case 'lastinvoices':
      return {
        dateFrom: [monday, lastMonday, firstDay, prevFirst][link],
        dateTo: [sunday, lastSunday, lastDay, prevLast][link],
        sampleRequest: 3, // no SR
        filename: getFilename(1, 'Last invoices'),
      }
    case 'dueinvoices':
      return {
        dateFrom: null,
        dateTo: [nextSunday, sunday, lastDay, prevLast][link],
        sampleRequest: 3, // no SR
        filename: getFilename(2, 'Due invoices'),
      }
    case 'orders':
      return {
        dateFrom: [monday, lastMonday, firstDay, prevFirst][link],
        dateTo: [sunday, lastSunday, lastDay, prevLast][link],
        sampleRequest: 3, // no SR
        relatedSPOs: 1, // no SPO
        showMarkup: 1, // no Markup
        filename: getFilename(3, 'Orders'),
      }
    case 'noninvoiced':
      return {
        dateFrom: null,
        dateTo: [sundayAfterNext, nextSunday, lastDay, prevLast][link],
        sampleRequest: 3, // no SR
        sortType: 3,
        showRelatedPFSPOs: false,
        filename: getFilename(4, 'OC'),
      }
    case 'offers':
      return {
        dateFrom: [last4CW, last5CW, firstDay, prevFirst][link],
        dateTo: [sunday, lastSunday, lastDay, prevLast][link],
        sampleRequest: 3, // no SR
        reportsmailer: true,
        filename: getFilename(5, 'OF'),
      }
    case 'lastinvoices_sr':
      return {
        dateFrom: [monday, lastMonday, firstDay, prevFirst][link],
        dateTo: [sunday, lastSunday, lastDay, prevLast][link],
        sampleRequest: 2, // SR only
        filename: getFilename(6, 'Last invoices', true),
      }
    case 'orders_sr':
      return {
        dateFrom: [monday, lastMonday, firstDay, prevFirst][link],
        dateTo: [sunday, lastSunday, lastDay, prevLast][link],
        sampleRequest: 2, // SR only
        relatedSPOs: 1, // no SPO
        showMarkup: 1, // no Markup
        filename: getFilename(7, 'Orders', true),
      }
    case 'noninvoiced_sr':
      return {
        dateFrom: null,
        dateTo: null,
        sampleRequest: 2, // SR only
        sortType: 3,
        filename: getFilename(8, 'OC', true),
      }
    case 'boxes':
      return {
        expiryReport: true,
        stockStatus: {
          notInInventory: false,
          onStock: true,
          shipped: false,
        },
        filename: getFilename(9, 'Inventory'),
      }
    case 'salesreport':
      return {
        regions: [],
        rsms: data.users.filter(f => f.erpRoles?.salesReport)?.map(m => mongoId(m.contact)),
        bus: [],
        customers: [],
        dateFrom: [monday, lastMonday, firstDay, prevFirst][link].toISOString(),
        dateTo: [sunday, lastSunday, lastDay, prevLast][link].toISOString(),
        activitytypes: [] as any,
        hideTopics: false,
        withOverview: false,
        hideActivityByProject: true,
        filename: getFilename(10, 'Sales') + '.pdf'
      }
    case 'plannedreport':
      return {
        regions: [],
        rsms: data.users.filter(f => f.erpRoles?.salesReport)?.map(m => mongoId(m.contact)),
        bus: [],
        customers: [],
        dateFrom: [nextMonday, monday, firstDay, prevFirst][link].toISOString(),
        dateTo: [nextSunday, sunday, lastDay, prevLast][link].toISOString(),
        activitytypes: [] as any,
        hideTopics: false,
        withOverview: false,
        hideActivityByProject: true,
        plannedActivityReport: true,
        filename: getFilename(11, 'PlannedActivitiesReport') + '.pdf'
      }
    case 'activityoverview':
      return {
        regions: [],
        rsms: data.users.filter(f => f.erpRoles?.salesReport)?.map(m => mongoId(m.contact)),
        bus: [],
        customers: [],
        dateFrom: [monday, lastMonday, firstDay, prevFirst][link].toISOString(),
        dateTo: [next4CW, next4CW, lastDay, prevLast][link].toISOString(),
        activitytypes: [] as any,
        hideTopics: false,
        withOverview: false,
        hideActivityByProject: true,
        activityOverview: true,
        filename: `${moment().format('YYMMDD')}_ActivityOverview.pdf`,
      }

  }

} 